import { useState } from "react"
import TabsGroup from "~/ui-rtk/components/ui/controls/TabsGroup/TabsGroup"
import { H3, P } from "~/ui-rtk/components/ui/typography"
import AdNamingSettings from "~/ui-rtk/components/features/settings/AdNamingSettings"
import CategoriesTab from "./components/CategoriesTab"
import CoverageTab from "./components/CoverageTab"

/**
 * One home for the creative-tag taxonomy.
 *
 * Before this page the pieces were scattered: the naming convention lived at
 * the bottom of Company Settings, and the categories/values it references had
 * no management screen at all — a company could accumulate 100+ hook values
 * with no way to see, rename, or remove one. Both halves belong together,
 * because the convention is defined in terms of the categories.
 */

const TABS = [
  { label: "Categories & Values" },
  { label: "Coverage" },
  { label: "Naming Convention" },
]

export default function TagManagementPage() {
  const [tabIndex, setTabIndex] = useState(0)

  return (
    <div className="flex flex-col gap-system-lg">
      <div>
        <H3 className="text-white font-bold text-2xl">Tags</H3>
        <P className="text-system-gray-400 mt-1">
          The creative taxonomy: the categories ads are tagged with, the values
          each category allows, and the naming convention built from them.
        </P>
      </div>

      <TabsGroup options={TABS} index={tabIndex} onChange={setTabIndex} />

      {tabIndex === 0 && <CategoriesTab />}
      {tabIndex === 1 && <CoverageTab />}
      {tabIndex === 2 && <AdNamingSettings />}
    </div>
  )
}
